import React, {useState, useEffect} from 'react'
import { deleteItem } from '../redux/actions/cartAction'
import { useSelector, useDispatch } from 'react-redux'

const Cart = () => {

  const dispatch = useDispatch()
  const {cartItems} = useSelector(state=>state.cart)
  const [totalPrice, setTotalPrice] = useState(0)

  const totalPriceHandler = () => {
    let total = 0
    cartItems.map((item)=>{
      total += (item.variant_price * item.quantity)
    })
    setTotalPrice(total)
  }

  useEffect(() => {
    if (cartItems) { 
      totalPriceHandler()
    }
  }, [cartItems])

  const removeItemHandler = (id) => {
    dispatch(deleteItem(id))
  }
  
  const handleCheckout = () => {
    localStorage.setItem("checkoutItems", JSON.stringify(cartItems) )
    document.getElementById("checkoutAnchorTag").click()
  }

  return (
    <div className="modal fixed-right fade show" id="modalShoppingCart" tabIndex="-1" role="dialog" style={{display:"none", paddingRight:"15px"}} aria-modal="true">
      <div className="modal-dialog modal-dialog-vertical" role="document">

        {cartItems.length !== 0 ? 
        <>
        <div className="modal-content">
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <i className="bi bi-x" style={{fontSize:"1.75rem"}} aria-hidden="true"></i>
          </button>

          <div className="modal-header line-height-fixed font-size-lg">
            <strong className="mx-auto">Your Cart ({cartItems.length})</strong>
          </div>

          <ul className="list-group list-group-lg list-group-flush">
            {cartItems.map((item, index)=>(
              <li className="list-group-item" key={index}>
              <div className="row align-items-center">
                <div className="col-4">

                  <a href={`/collections/framed-art/products/${item.handle}`}>
                    <img className="img-fluid" src={item.variant_image} alt="..."/>
                  </a>

                </div>
                <div className="col-8">

                  <p className="font-size-sm font-weight-bold mb-6">
                    <a className="text-body" href={`/collections/framed-art/products/${item.handle}`}>{item.title}</a> <br/>
                    <span className="text-muted">Rs. {item.variant_price}</span>
                  </p>

                  <div className="d-flex align-items-center">

                    <p className='mb-0 text-muted font-size-xs'>Quantity: {item.quantity}</p>

                    <a className="font-size-xs text-gray-400 ml-auto cursor-pointer" onClick={()=>removeItemHandler(item._id)}>
                      <i className="fe fe-x"></i> Remove
                    </a>

                  </div>

                </div>
              </div>
            </li>
            ))}
          </ul>

          <div className="modal-footer line-height-fixed font-size-sm bg-light mt-auto">
            <strong>Subtotal</strong> <strong className="ml-auto">Rs {totalPrice}</strong>
          </div>

          <div className="modal-body">
            <button className="btn btn-block btn-dark" onClick={handleCheckout}>Continue to Checkout</button>
            <a className="btn btn-block btn-outline-dark" href="/cart">View Cart</a>
          </div>

        </div>

        </>
        :
        <div className="modal-content">

          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <i className="fe fe-x" aria-hidden="true"></i>
          </button>

          <div className="modal-header line-height-fixed font-size-lg">
            <strong className="mx-auto">Your Cart (0)</strong>
          </div>

          <div className="modal-body flex-grow-0 my-auto">

            <h6 className="mb-7 text-center">Your cart is empty 😞</h6>

            <a className="btn btn-block btn-outline-dark" href="/collections/framed-art">
              Continue Shopping
            </a>

          </div>

        </div>
        }
      </div>
      <a href="/checkout" id='checkoutAnchorTag' className="d-none"></a>
    </div>
  )
}

export default Cart